import { inspect } from '@xstate/inspect';
import { IS_PROD_URL } from './constants';

export const initXstateInspect = () => {
  if (!IS_PROD_URL && XSTATE_INSPECTOR_ON) {
    inspect({
      // options
      url: 'https://statecharts.io/inspect', // (default)
      iframe: false, // open in new window
    });
  }
};
